// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"179":"main","389":"YTMediaAPI","727":"YTDataAPI"}[chunkId] || chunkId) + ".css";
};